import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';
import InvitationList from '../../../../invitationList';
import {pathResolver} from '../../../../../utils/basePathHelper';

const InvitationsView = props => (
  <>
    <h2>
      <Translate value="invitation.received.title"/>
    </h2>
    {isEmpty(props.invitations) &&
        <div
          className="card d-flex flex-column justify-content-center align-items-center font-size-m"
          style={{minHeight: 200}}
        >
          <img
            alt="validated"
            src={pathResolver('resources/svg/checklist-validated.svg')}
            height={70}
            className="mb-4"
          />
          <Translate value="invitation.received.emptyList"/>
        </div>
    }
    <InvitationList
      invitations={props.invitations}
      canAddUser={props.canAddUser}
      onAccept={props.onAccept}
      onReject={props.onReject}
    />
  </>
);

InvitationsView.propTypes = {
  invitations: PropTypes.array.isRequired,
  canAddUser: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};

export default InvitationsView;
